import axios from 'axios';
import { IMAGE_WEBHOOK_URL } from '../config';

export async function enviarImagem(identidade, ingresso, campanha, matricula) {
  const formData = new FormData();
  formData.append('identidade', identidade);
  formData.append('ingresso', ingresso);
  formData.append('campanha', campanha);
  formData.append('matricula', matricula);

  const response = await axios.post(IMAGE_WEBHOOK_URL, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    auth: { username: 'webhookmarkt', password: 'Bemol@99' },
    timeout: 180000,
  });

  const data = response.data;
  if (Array.isArray(data) && data[0]?.html) return data[0].html;
  if (data?.html) return data.html;
  if (Array.isArray(data) && data[0]?.text) return data[0].text;
  if (data?.text) return data.text;
  return 'Imagens recebidas e processadas com sucesso!';
}
